export enum PartialSettlementType {
  ReducePayment = 'REDUCE_PAYMENT',
  ReduceTerm = 'REDUCE_TERM',
}
